import React from 'react';

import {
  Col,
} from "react-bootstrap";

const ExperienceCard = ({ data, imageWidth, imageHeight}) => {
  return (
    <Col>
      <div className="pb-5 text-center">

        <img
         className=" bg-white mb-3"
          src={data.companylogo}
           alt=""
           width={imageWidth}
           height={imageHeight}
           style={{flex:1, height: 70, width: 250}}
           resizeMode="contain"
          />
        <p className="lead">
          {data.role}
          <br />
          {data.date}
        </p>
      </div>
    </Col>
  );
}

export default ExperienceCard;